/** Plate verdict: AI-reading vs record decisions, shared by client and server. Pure. */
export * from './types';
export * from './normalize';
export * from './compare';
export * from './verdict';
export * from './confirm';
export * from './sanitize';
export * from './junkRules';
export * from './knownMakes';
export * from './judge';
